import { render, staticRenderFns } from "./Letter.vue?vue&type=template&id=21523078&scoped=true"
import script from "./Letter.vue?vue&type=script&lang=js"
export * from "./Letter.vue?vue&type=script&lang=js"
import style0 from "./Letter.vue?vue&type=style&index=0&id=21523078&prod&scoped=true&lang=css"
import style1 from "./Letter.vue?vue&type=style&index=1&id=21523078&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21523078",
  null
  
)

export default component.exports